// extracted by mini-css-extract-plugin
export default {"box_07":"index_box_07_SgGPp","clearfix":"index_clearfix_P4BzG","box_07_a":"index_box_07_a_Cihxj","bag":"index_bag_BZPKA","text_02":"index_text_02_qj-1v"};